import { Stack, Button, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import update from "../../../api/auth/orders/update";
import useOrderStore from "../../../stores/useOrderStore";
import WushTextField from "../WushTextField";
import useAlertStore from "../../../stores/useAlertStore";

export default function OrderCommentForm({ order }) {
  const { register, handleSubmit } = useForm();

  const { updateOrder } = useOrderStore();

  const { setAlertMessage } = useAlertStore();

  const onSubmit = (data) => {
    update(order.id, data, (response) => {
      updateOrder(response);
      setAlertMessage('Comment saved!', 'success');
    });
  };

  return (
    <Stack>
      <Stack mb={1}>
        <Typography variant="h4">Order Comments</Typography>
      </Stack>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack mb={1}>
          <WushTextField formRegistration={register('admin_comments')} label="Admin Comments" defaultValue={order.admin_comments} multiline />
        </Stack>
        <Stack direction="row">
          <Button type="submit" variant="contained">Save</Button>
        </Stack>
      </form>
    </Stack>
  );
}